import type { RawParams } from "@uirouter/react";

import type { IAutoCompleteRecentItem } from "app/@types/autocomplete";

export type Timestamp = string;

export enum AppStore {
    Google = 0,
    Apple = 1,
}

export type AppStoreStr = "google" | "apple";

export type StateObjectType =
    | "website"
    | "app"
    | "virtual"
    | "keyword"
    | "industry"
    | "appCategory"
    | "googlePlayKeyword"
    | "advertiser"
    | "publisher"
    | "conversionIndustry"
    | "company";

export interface PageId {
    section: string;
    subSection?: string;
    subSubSection?: string | null;
    pageId?: string;
}

export interface IStateResourceObject {
    isCompare?: boolean;
    mainItemFavIcon?: string;
    domainIcons?: string[];
    iconClass?: string;
    companyName?: string;
}

export interface IStateObject {
    type: StateObjectType;
    mainItem: string;
    comparedItems?: string[];
    domains?: string[];
    resources?: IStateResourceObject;
    appStore?: AppStore;
    origin?: string;
    duration?: string;
    comparedDuration?: string;
    country?: number;
    industry?: string;
    category?: string;
    pageId?: PageId;
    keyword?: string;
    searchTerm?: string[];
    keywordGroup?: string[];
    topic?: string[];
    aiTopic?: string[];
    webSource?: string;
    store?: string;
    device?: string;
    mode?: string;
    hideFromRecents?: boolean;
    stateName?: string;
    pageTitle?: string;
    params?: RawParams;
    visits?: number;
    forbidTrackerSuggestion?: boolean;
}

export interface IBaseDataObject {
    id: string;
    data: IStateObject;
}

export interface IFavoriteObject extends IBaseDataObject {
    addedTime: Timestamp;
}

export interface IFavorites {
    freeSlots: number;
    items: IFavoriteObject[];
    virtualItems: IFavoriteObject[];
}

export interface IAlertDataObject {
    change: number;
}

export interface IAlertObject {
    creationDate: string;
    data: IAlertDataObject;
    from: string;
    icon: string;
    id: string;
    isNew: boolean;
    isRead: boolean;
    site: string;
    to: string;
    type: string;
}

export interface IAlerts {
    items: IAlertObject[];
    newCount: number;
    unReadCount: number;
}

export interface IRecentObject extends IBaseDataObject {
    updatedTime: Timestamp;
    isFavorite: boolean;
    isPurchased?: boolean;
}

export interface ISearchObject {
    id: string;
    searchTime: Timestamp;
    data: IAutoCompleteRecentItem;
}

export type IRecents = IRecentObject[];

export type ISearches = ISearchObject[];

export interface UserDataConfig {
    favorites: IFavorites;
    alerts?: IAlerts;
    recent: IRecents;
    dashboards: any;
    preferences: any;
    features: { [feature: string]: boolean };
}

export type ISortDirection = "asc" | "desc";

export type ISortedColumn = {
    field: string;
    sortDirection: ISortDirection;
};
